import { h, Component } from 'preact';
import HTML from 'components/core/html/html.js';
import { joinClasses } from 'utils/utils';
import { travelerNotices } from 'helpers/airportData.js';
import Store from 'store/store';
import s from 'components/bolt/airport/popUpWindows/travelerNotices/travelerNotices.sss';
export default class TravelerNotices extends Component {
	constructor(props) {
		super(props);
		this.onPlay = this.onPlay.bind(this);
		this.onPause = this.onPause.bind(this);
		this.onEnded = this.onEnded.bind(this);
		this.progressTracker = this.progressTracker.bind(this);
		this.handleEasterEggButtonClick = this.handleEasterEggButtonClick.bind(this);

		this.$video;
		this.progressTracking = {};
		this.timer;
		this.videoIsPlaying = false;

		this.state = {
			activeTravelerNotice: travelerNotices[0].id,
			viewedTravelerNotices: [travelerNotices[0].id]
		};
		this.notices = travelerNotices.filter(s => !s.disabled);
	}

	componentDidMount() {
		const viewedTravelerNoticesStored = JSON.parse(localStorage.getItem('viewedTravelerNotices'));
		if (viewedTravelerNoticesStored?.length > 0) {
			this.setState({ viewedTravelerNotices: viewedTravelerNoticesStored });
		} else {
			localStorage.setItem('viewedTravelerNotices', JSON.stringify(this.state.viewedTravelerNotices));
		}
	}

	componentWillUnmount() {
		cancelAnimationFrame(this.timer);
	}

	onPlay() {
		this.videoIsPlaying = true;
		Store.emit('PAUSE_MUSIC');
		this.progressTracking = {};
		this.progressTracker();
	}

	onPause() {
		this.videoIsPlaying = false;
		Store.emit('RESUME_MUSIC');
		cancelAnimationFrame(this.timer);
	}

	onEnded() {
		this.videoIsPlaying = false;
		Store.emit('RESUME_MUSIC');
		cancelAnimationFrame(this.timer);
	}

	progressTracker() {
		if (!this.$video || !this.videoIsPlaying ) {
			return;
		}
		const progress = this.$video.currentTime / this.$video.duration;
		let step = [0, 25, 50, 75, 95].find(step => progress > (step / 100) && !this.progressTracking[step]);

		if (step || step === 0) {
			this.progressTracking[step] = true;

			Store.emit('CUSTOM_EVENT', {
				category: 'traveller-notices',
				action: 'traveller-notice-video-playback',
				label: `${step} percentage completion`
			});
		}

		this.timer = requestAnimationFrame(this.progressTracker);
	}
	
	handleEasterEggButtonClick(id, e) {
		e.stopPropagation();
		Store.emit('OPEN_EASTER_EGG', id); 
	}

	travelerNoticeSelectTab(id) {
		this.setState({ activeTravelerNotice: id });

		Store.emit('CUSTOM_EVENT', {
			category: 'traveller-notices',
			action: 'traveller-notice-tab-click',
			label: id
		});
	
		const { viewedTravelerNotices } = this.state;
		if (!viewedTravelerNotices.includes(id)) {
			viewedTravelerNotices.push(id);
			this.setState({ viewedTravelerNotices });
			localStorage.setItem('viewedTravelerNotices', JSON.stringify(viewedTravelerNotices));
		}
	}


	renderTravelerNoticeTab(notice, popUpCopy) {
		const { imageRoot, imageRegionRoot, videoRegionRoot, client, isOpen } = this.props;
		const { activeTravelerNotice } = this.state;
		const isActive = activeTravelerNotice === notice.id;

		if (this.$video) {
			if (isOpen && activeTravelerNotice == 'videoMessage') {
				if (!this.videoIsPlaying) {
					this.$video.play();
				}
			} else {
				if (this.videoIsPlaying) {
					this.$video.pause();
				}
			}
		}

		let region = Store.get()?.appData?.meta?.region?.slug;
		let smallerText = popUpCopy.missingAlert.length > 180 || region == 'jp';

		return (
			<div class={joinClasses(s.travelerNotice, s[notice.id], isActive && s.activeNotice)} key={`${notice.id}-notice`}>
				{notice.id === 'missingPoster' && [
					<img
						class={s.noticeImage}
						src={`${notice.imageRegion ? imageRegionRoot : imageRoot}/airport/${client.isDesktopWidth ? notice.imageDesktop : notice.imageMobile}`}
					/>,
					<div class={joinClasses( s.noticeTextContainer, smallerText && s.smallerText)}>
						<HTML
							class={s.noticeText}
							markdown
							content={popUpCopy.missingAlert}
						/>
					</div>
				]}
				{notice.id === 'starfox' && [
					<div
						class={s.noticeImage}
					>
						<img
							class={s.noticeImage}
							src={`${notice.imageRegion ? imageRegionRoot : imageRoot}/airport/${client.isDesktopWidth ? notice.imageDesktop : notice.imageMobile}`}
						/>
						<button
							class={s.easterEggButton}
							onClick={(e) => this.handleEasterEggButtonClick(notice.id, e)}
						>
							<img alt={popUpCopy.starfoxButton} class={s.icon} src={`${imageRoot}/airport/KR9jNW.webp`} />
							<img  alt={popUpCopy.starfoxButton} class={s.iconHover} src={`${imageRoot}/airport/K9FkYL.webp`} />
						</button> {/*TRAVELER NOTICE EASTER EGG UPDATE */}
					</div>,
					<div class={s.noticeTextContainer}>
						<HTML
							class={s.noticeText}
							markdown
							content={popUpCopy.starfox}
						/>
					</div>,
			
				]}
				{notice.id === 'ukikiWarning' && [
					<div
						class={s.noticeImage}
					>
						<img
							class={s.noticeImage}
							src={`${notice.imageRegion ? imageRegionRoot : imageRoot}/airport/${client.isDesktopWidth ? notice.imageDesktop : notice.imageMobile}`}
						/>
					</div>,
					<div class={s.noticeTextContainer}>
						<HTML
							class={s.noticeText}
							markdown
							content={popUpCopy.ukikiWarning}
						/>
					</div>
				]}
				{notice.id === 'videoMessage' && (
					<video
						class={s.noticeVideo}
						ref={ref => this.$video = ref} 
						playsInline
						controls
						onplay={this.onPlay}
						onended={this.onEnded}
						onpause={this.onPause}
						poster={`${imageRoot}/oj2b6s.webp`}
					>
						<source src={`${videoRegionRoot}/oj2b6s.mp4`} type={'video/mp4'} />
						<source src={`${videoRegionRoot}/oj2b6s.webm`} type={'video/webm'} />
					</video> 
				)}
			</div>
		);
	}

	render({ section, imageRoot }) {
		const { activeTravelerNotice, viewedTravelerNotices } = this.state;
		const popUpCopy = section.popUp?.copy;

		return (
			<div class={s.container}>
				<div class={s.tabs} onMouseDown={(e) => e.stopPropagation()} onTouchStart={(e) => e.stopPropagation()}>
					{this.notices.map(notice => (
						<button
							class={joinClasses(s.travelerNoticeTab, activeTravelerNotice === notice.id && s.activeTab)}
							key={`${notice.id}-tab`}
							onClick={() => this.travelerNoticeSelectTab(notice.id)}
						>
							<img class={s.tabIcon} src={`${imageRoot}/airport/${notice.tabIcon}`} />
							<img
								class={joinClasses(s.alertIcon, viewedTravelerNotices.includes(notice.id) && s.hidden)}
								src={`${imageRoot}/airport/gh6kcn.webp`}
							/>
						</button>
					))}
				</div>
				<div
					class={s.noticeContainer}
					onMouseDown={(e) => e.stopPropagation()}
					onTouchStart={(e) => e.stopPropagation()}
				>
					{this.notices.map(notice => this.renderTravelerNoticeTab(notice, popUpCopy))}
				</div>
			</div>
		);
	}
}
